import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 28px 5%;
  position: fixed;
  width: 100%;
  z-index: 10;
  background-color: white;
`;

export const LogoContainer = styled.div`
  cursor: pointer;
`;

export const SocialLinksAndSignUpButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 32px;
  & > a > svg {
    display: block;
  }
  @media (max-width: 600px) {
    & > a {
      display: none;
    }
  }
`;

export const SignUpButton = styled.button`
  background: #6944a3;
  border-radius: 8px;
  padding: 8px 12px;
  gap: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  font-size: 14px;
  line-height: 130%;
  color: #ffffff;
  cursor: pointer;
  border: none;
  &:hover {
    opacity: 0.9;
  }
`;

export const Link = styled.a`
  font-weight: 500;
  font-size: 16px;
  line-height: 130%;
  @media (max-width: 600px) {
    display: none;
  }
  &:hover {
    opacity: 0.8;
    cursor: pointer;
  }
`;
